var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEgyptsymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 131,
    viewBox: "0 0 98 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0894 87.2079C57.4245 86.7886 60.1627 85.8722 60.1627 85.8722L60.0519 110.866C60.0519 110.866 59.2337 115.066 48.5812 115.019C37.8513 114.971 37.0962 110.764 37.0962 110.764L37.207 85.7704C37.207 85.7704 39.7564 86.7103 44.1393 87.1682",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1609 97.4947L45.2285 97.4684L45.2262 97.9842L51.1586 98.0105L51.1609 97.4947Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9429 95.6633L46.3975 95.6387L46.3952 96.1545L51.9406 96.1791L51.9429 95.6633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4092 93.8315L45.8379 93.8068L45.8356 94.3226L51.4069 94.3473L51.4092 93.8315Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3456 92.0048L44.7109 91.9709L44.7086 92.4868L52.3433 92.5207L52.3456 92.0048Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5343 90.1746L44.5127 90.139L44.5104 90.6549L52.532 90.6905L52.5343 90.1746Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7235 88.3181L44.3408 88.2809L44.3385 88.7967L52.7212 88.8339L52.7235 88.3181Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9118 86.4858L44.168 86.447L44.1657 86.9629L52.9095 87.0017L52.9118 86.4858Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1006 84.6555L44.0215 84.6152L44.0192 85.1311L53.0983 85.1714L53.1006 84.6555Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2898 82.8273L43.8496 82.7854L43.8473 83.3013L53.2875 83.3431L53.2898 82.8273Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4785 80.9951L43.6514 80.9515L43.6491 81.4674L53.4762 81.511L53.4785 80.9951Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 79.1648L43.4785 79.1196L43.4762 79.6355L53.6644 79.6807L53.6667 79.1648Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8559 77.3083L43.3066 77.2615L43.3044 77.7773L53.8536 77.8241L53.8559 77.3083Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0958 75.4762L43.1338 75.4276L43.1315 75.9435L54.0935 75.9921L54.0958 75.4762Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2324 73.6479L42.9609 73.5979L42.9586 74.1138L54.2301 74.1637L54.2324 73.6479Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4475 71.8177L42.7891 71.766L42.7868 72.2818L54.4452 72.3335L54.4475 71.8177Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6357 69.9854L42.6162 69.9321L42.6139 70.448L54.6334 70.5013L54.6357 69.9854Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7991 68.1571L42.4443 68.1023L42.442 68.6182L54.7968 68.6729L54.7991 68.1571Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9874 66.2986L42.2715 66.2422L42.2692 66.758L54.9851 66.8144L54.9874 66.2986Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1763 64.4668L41.9961 64.4083L41.9938 64.9242L55.174 64.9826L55.1763 64.4668Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3647 62.6403L41.875 62.5804L41.8727 63.0963L55.3624 63.1561L55.3647 62.6403Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7414 59.2352L51.6449 98.8873C50.7339 100.74 46.2202 100.72 45.3257 98.8592L41.5811 59.1724",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9401 33.5892C65.9925 33.4089 67.3544 28.7463 61.6398 26.1417C56.6203 23.8496 41.3508 23.7819 36.3112 26.0293C30.5737 28.5832 31.8167 33.2831 31.8676 33.4381",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1948 11.9229C19.1948 11.9229 37.6097 0.655413 49.1133 0.706426C60.8233 0.758354 78.8538 12.1874 78.8538 12.1874",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0376 24.9066L73.2968 8.93439L76.4354 10.7796L64.6054 26.1774L63.0376 24.9066ZM33.473 26.1168L21.6775 10.4594C22.7126 9.69022 23.7972 9.4113 24.9095 8.69402L34.9495 24.7047L33.473 26.1168ZM36.6553 23.9384L27.8306 7.23675C28.9681 6.64855 30.0795 6.13761 31.2425 5.6269L38.5928 23.2506L36.6553 23.9384ZM59.3813 23.4718L67.1974 5.86372L70.4147 7.42559L61.3127 24.1767L59.3813 23.4718ZM40.4257 22.8976L34.0848 4.4788L37.4437 3.17823L42.4392 22.5454L40.4257 22.8976ZM55.6713 22.5267L60.8639 3.2305L64.2113 4.53501L57.63 22.8707L55.6713 22.5267ZM44.2455 22.3729L40.5433 2.18603L44.0551 1.32463L46.2576 22.3044L44.2455 22.3729ZM51.8807 22.2778L54.1924 1.21482L57.7218 2.18483L53.8664 22.364L51.8807 22.2778ZM48.0894 22.2094L47.3073 0.823181L50.9182 0.864987L50.1011 22.2441L48.0894 22.2094Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8936 33.4393C31.0528 31.0883 30.6239 28.9456 30.2431 27.551C27.2503 16.1113 19.1955 11.9228 19.1955 11.9228L0.858393 63.8152C2.91062 66.3521 12.0702 71.4998 14.5605 74.1418C19.9004 79.8142 17.9574 104.98 23.5292 110.705C29.7943 117.13 37.4669 114.429 37.1221 110.765L37.3663 55.6974",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9406 33.5885C66.8545 31.0648 67.2239 29.2093 67.6432 27.7151C70.7374 16.3024 78.829 12.1855 78.829 12.1855L96.7051 64.2385C94.6305 66.757 85.4256 71.8233 82.912 74.4431C77.522 80.068 79.2417 105.25 73.6194 110.925C67.2975 117.294 59.6491 114.526 60.0265 110.865L60.2707 55.7972",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0786 69.3678C91.9442 73.2709 94.6423 81.4078 94.9901 96.0342C95.4269 113.859 87.7355 120.789 80.7033 124.498C67.2594 131.558 48.5115 130.675 48.5115 130.675",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4605 130.676C48.4605 130.676 29.7313 131.393 16.3247 124.215C9.29987 120.443 1.67026 113.445 2.29095 95.6247C2.79417 81.0279 5.53834 72.9409 7.43861 69.0288",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3242 118.125C37.5759 119.072 42.6295 119.508 48.5622 119.456",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3184 92.526C13.4665 105.656 18.458 114.267 31.7004 117.756",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7055 82.084C14.7055 82.084 13.5446 87.9339 13.3253 90.8734",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.873 109.689C21.5894 117.711 32.7681 121.242 48.5547 121.003",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5561 84.2669C10.5762 94.4981 11.4696 102.421 14.9259 108.239",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4863 119.827C33.1528 121.658 40.1648 122.514 48.4956 122.603",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1719 98.1855C11.0284 108.61 15.9517 115.157 24.7569 118.808",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3249 82.5332C10.3211 87.868 9.91334 92.5606 10.1014 96.6884",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68066 108.856C13.732 121.44 27.6104 126.893 48.4785 126.624",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2803 82.906C6.01853 92.7233 6.03466 100.719 8.06995 107.074",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2695 123.219C26.6549 127.121 36.5779 128.816 48.4693 128.662",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66848 84.2375C2.02682 102.767 6.30662 114.831 16.568 121.635",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34993 83.5571L17.4671 81.711",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8288 116.452C64.5316 118.595 57.5371 119.622 48.4842 119.478",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6957 82.3866C82.6957 82.3866 84.0317 89.3825 84.0205 91.9102C83.9724 102.743 80.8165 110.622 72.6975 115.1",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4156 106.299C78.5969 116.879 66.5053 121.442 48.5035 121.001",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4492 82.6246C86.0661 90.2667 86.1925 96.664 84.9311 101.92",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.674 122.3C54.1196 122.495 51.4109 122.587 48.522 122.6",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3993 84.7493C90.1377 108.393 81.4758 118.981 61.3186 121.806",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3781 126.038C57.4554 126.51 53.1728 126.698 48.5305 126.6",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6738 98.2066C90.3211 107.955 86.6788 114.98 80.1583 119.62C77.4674 121.517 74.2881 123.025 70.6463 124.143C68.5025 124.804 66.2047 125.31 63.7525 125.712",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1152 83.2609C89.9244 86.9271 90.4251 90.3341 90.6174 93.5075",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2605 128.678C51.0223 128.699 49.7842 128.693 48.5205 128.662",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6145 119.532C77.0634 125.255 67.275 128.126 54.9435 128.613",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M92.191 87.5586C94.3192 102.038 91.3592 112.265 84.314 118.888",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5117 83.6094C91.6885 84.4613 91.8396 85.2874 91.965 86.0875",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0377 83.9576L79.9375 81.9863",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0547 110.271L74.1376 110.333L72.2466 112.156L60.0466 112.102L60.0547 110.271Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0703 106.638L75.8814 106.708L75.1769 108.51L60.0623 108.443L60.0703 106.638Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0869 103L76.8265 103.075L76.4316 104.878L60.0789 104.806L60.0869 103Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1035 99.3367L77.4621 99.4136L77.1703 101.244L60.0954 101.168L60.1035 99.3367Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1191 95.6974L77.8647 95.7761L77.7276 97.6068L60.111 97.5287L60.1191 95.6974Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1357 92.062L78.3455 92.1428L78.2086 93.9477L60.1277 93.8675L60.1357 92.062Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1523 88.3983L78.878 88.4814L78.6635 90.3117L60.1442 90.2296L60.1523 88.3983Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.168 84.7651L79.4353 84.8506L79.1434 86.6806L60.1598 86.5964L60.168 84.7651Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1846 81.1257L80.1225 81.2141L79.7276 83.0179L60.1766 82.9312L60.1846 81.1257Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2002 77.462L81.1182 77.5548L80.5685 79.3837L60.1921 79.2933L60.2002 77.462Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2158 73.8268L83.3521 73.9294L81.9769 75.7546L60.2077 75.6581L60.2158 73.8268Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2324 70.1915L88.4756 70.3168L85.811 72.1105L60.2244 71.997L60.2324 70.1915Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M60.249 66.5278L93.8056 66.6766L91.1924 68.4964L60.2409 68.3591L60.249 66.5278Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2646 62.8905L96.3231 63.0504L96.7306 64.2387L96.1087 64.8808L60.2565 64.7218L60.2646 62.8905Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2812 59.2532L95.0759 59.4075L95.6869 61.2157L60.2732 61.0587L60.2812 59.2532Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2969 55.5916L93.8019 55.7401L94.4386 57.5743L60.2888 57.4228L60.2969 55.5916Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0215 51.9667L92.5544 52.0977L93.1138 53.9315L62.0075 53.7936L63.0215 51.9667Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0985 48.3559L91.4352 48.4549L91.9172 50.2626L67.5945 50.1547L69.0985 48.3559Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0189 44.6952L90.1632 44.7845L90.6709 46.6181L69.6755 46.525L70.0189 44.6952Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6529 41.0617L88.8627 41.1424L89.422 42.9762L70.361 42.8917L70.6529 41.0617Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0879 37.4338L87.6927 37.503L88.1747 39.3107L71.5125 39.2368L72.0879 37.4338Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5371 33.7697L86.3422 33.8353L86.9016 35.6691L72.0964 35.6035L71.5371 33.7697Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0136 30.1133L85.146 30.1937L85.6538 32.0273L66.2575 31.9413L67.0136 30.1133Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0864 26.4774L83.8717 26.5474L84.4053 28.3553L67.4852 28.2802L68.0864 26.4774Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2378 22.8217L82.6501 22.8812L83.1836 24.7149L68.6364 24.6504L69.2378 22.8217Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M71.292 19.1938L81.4544 19.2389L81.8848 21.0721L70.4069 21.0212L71.292 19.1938Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2221 15.5687L80.0513 15.5945L80.6365 17.4027L72.8729 17.3682L74.2221 15.5687Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0904 112.005L24.8904 111.951L23.0156 110.111L37.0986 110.174L37.0904 112.005Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1058 108.341L21.9911 108.274L21.3027 106.466L37.1138 106.536L37.1058 108.341Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1232 104.706L20.7705 104.634L20.3916 102.826L37.1312 102.901L37.1232 104.706Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1386 101.069L20.0637 100.993L19.7881 99.1606L37.1467 99.2376L37.1386 101.069Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1554 97.4314L19.5388 97.3532L19.418 95.5214L37.1635 95.6001L37.1554 97.4314Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1715 93.7663L19.0907 93.6861L18.9697 91.88L37.1795 91.9608L37.1715 93.7663Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1873 90.1327L18.6679 90.0506L18.4697 88.2184L37.1954 88.3014L37.1873 90.1327Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2035 86.4936L18.2199 86.4095L17.9443 84.5769L37.2116 84.6623L37.2035 86.4936Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2199 82.8335L17.6689 82.7468L17.29 80.9396L37.228 81.028L37.2199 82.8335Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2351 79.1959L16.8587 79.1056L16.3252 77.2719L37.2432 77.3646L37.2351 79.1959Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2521 75.5583L15.4829 75.4617L14.124 73.6244L37.2603 73.727L37.2521 75.5583Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2684 71.8975L11.6819 71.7841L9.0332 69.9668L37.2764 70.092L37.2684 71.8975Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2838 68.259L6.33231 68.1218L3.73535 66.2789L37.2919 66.4277L37.2838 68.259Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 64.6203L1.44782 64.4614L0.831653 63.8138L1.2496 62.6291L37.3081 62.7891L37.3 64.6203Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3158 60.9607L1.90215 60.8037L2.52919 59.0009L37.3238 59.1552L37.3158 60.9607Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3321 57.3233L3.18231 57.1719L3.83525 55.3434L37.3402 55.492L37.3321 57.3233Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35.646 53.6765L4.53973 53.5386L5.11529 51.7098L34.6482 51.8408L35.646 53.6765Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0911 49.9914L5.76836 49.8835L6.26643 48.0802L28.6031 48.1792L30.0911 49.9914Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0439 46.3429L7.04852 46.2498L7.5725 44.4207L27.7168 44.5101L28.0439 46.3429Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3897 42.705L8.32879 42.6205L8.90436 40.7917L27.1141 40.8725L27.3897 42.705Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2704 39.0394L9.6082 38.9655L10.1063 37.1622L25.711 37.2314L26.2704 39.0394Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7189 35.3973L10.9138 35.3317L11.4893 33.5029L26.2944 33.5685L25.7189 35.3973Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5913 31.7865L12.195 31.7004L12.719 29.8714L30.8514 29.9518L31.5913 31.7865Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3946 28.1185L13.4744 28.0434L14.0241 26.2403L29.8093 26.3103L30.3946 28.1185Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2754 24.4802L14.7282 24.4156L15.278 22.5868L28.6903 22.6462L29.2754 24.4802Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5381 20.8313L16.0602 20.7804L16.5068 18.951L26.6692 18.9961L27.5381 20.8313Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1033 17.1598L17.3396 17.1253L17.9409 15.3225L23.7701 15.3483L25.1033 17.1598Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9926 22.1638C71.123 22.262 65.9398 33.5881 65.9398 33.5881C65.9398 33.5881 67.784 48.1437 60.2958 55.797C60.2958 55.797 55.3187 61.3721 48.793 61.3689L48.7672 61.3688C46.3169 61.3579 44.1022 60.5485 42.2753 59.5603C39.239 57.896 37.3142 55.7208 37.3142 55.7208C29.8941 48.0015 31.8673 33.4628 31.8673 33.4628C31.8673 33.4628 26.7848 22.0911 48.9151 22.1893",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6931 28.7099C34.055 22.7472 32.7179 33.4455 32.7179 33.4455",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0263 33.7846C44.7059 29.0844 37.4543 29.9034 36.4959 30.8277C35.8224 31.4695 34.6065 32.2895 34.6065 32.2895",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3685 36.6159C32.3685 36.6159 33.4052 35.4856 35.0582 35.0029C36.4012 34.5961 36.6693 32.3017 40.3061 32.3178C44.5362 32.3366 45.2693 35.693 45.2693 35.693C45.2693 35.693 42.0966 35.7047 40.7548 35.8277C40.1356 35.8766 38.4577 36.1786 37.839 36.0985C37.2977 36.0187 36.2676 35.6531 35.7259 35.6507C34.8232 35.6467 32.3685 36.6159 32.3685 36.6159Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3948 35.8216C41.3777 35.8259 42.178 35.0327 42.1824 34.0498C42.1867 33.0669 41.3935 32.2665 40.4106 32.2622C39.4277 32.2578 38.6273 33.0511 38.623 34.034C38.6186 35.0169 39.4119 35.8172 40.3948 35.8216Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1777 37.2705C36.8545 37.2264 36.9048 37.5103 37.678 37.6427C39.3792 37.9082 41.0853 37.0646 45.1077 37.3661",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4657 28.7282C64.1563 22.8778 65.2437 33.5869 65.2437 33.5869",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M52.062 33.8141C53.424 29.1258 60.6681 30.0091 61.6183 30.9419C62.286 31.5897 63.4946 32.4204 63.4946 32.4204",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6936 36.7614C65.6936 36.7614 64.667 35.6219 63.0184 35.1245C61.679 34.7059 61.4312 32.4092 57.7944 32.393C53.5644 32.3743 52.8015 35.724 52.8015 35.724C52.8015 35.724 55.974 35.7639 57.3146 35.8988C57.9334 35.9532 59.6086 36.2701 60.2279 36.1955C60.7699 36.1205 61.8033 35.764 62.3449 35.7664C63.2477 35.7704 65.6936 36.7614 65.6936 36.7614Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M57.676 35.9018C58.6589 35.9061 59.4593 35.1129 59.4636 34.13C59.468 33.1471 58.6747 32.3467 57.6918 32.3424C56.7089 32.338 55.9086 33.1313 55.9042 34.1142C55.8999 35.0971 56.6931 35.8974 57.676 35.9018Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8795 37.3948C61.2031 37.3357 61.1503 37.6192 60.3759 37.7448C58.6725 37.9951 56.9739 37.1364 52.949 37.4023",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8126 30.6062C50.8047 32.3859 50.6082 35.9703 50.7809 37.7508C51.0777 40.6152 54.2103 43.8275 53.145 45.5767C52.4176 46.7342 50.7969 45.7726 50.0234 45.7176C49.1466 45.6621 47.4161 46.1961 46.5656 46.0376C46.1275 45.9583 44.9179 45.3597 44.9198 44.9212",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3557 51.7485C54.3557 51.7485 51.8072 50.6023 50.8786 50.6239C50.3627 50.6217 49.3552 50.9783 48.8394 50.9502C48.3237 50.9221 47.3449 50.6083 46.8291 50.606C45.9005 50.6019 43.0068 51.6982 43.0068 51.6982C43.0068 51.6982 45.199 51.7595 45.895 51.8399C46.6427 51.9206 48.0858 52.2107 48.8338 52.2141C49.6592 52.2177 51.2598 51.8895 52.0599 51.7899C52.705 51.7154 54.3557 51.7485 54.3557 51.7485Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1099 53.4956C53.1099 53.4956 51.0435 54.1571 50.3471 54.154C49.9602 54.1523 49.2394 53.8396 48.8526 53.8121C48.4658 53.7846 47.7162 54.1423 47.3293 54.1406C46.6328 54.1633 44.624 53.458 44.624 53.458C44.624 53.458 45.7526 54.8816 46.2932 55.1162C46.8853 55.3767 48.2275 55.1764 48.8722 55.205C49.4396 55.2075 50.5739 55.3415 51.0907 55.1375C51.685 54.908 53.1099 53.4956 53.1099 53.4956Z",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8942 33.4394C31.8942 33.4394 30.7669 31.7062 28.6763 32.0065C26.1727 32.3823 25.8512 35.0892 25.8196 36.4045C25.7874 37.8488 26.9407 39.5047 27.3936 42.086C28.1734 46.5517 28.3654 49.7768 30.403 49.7858C32.8018 49.7964 32.9658 47.7079 32.9658 47.7079",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7316 35.1957C31.7353 34.3445 29.704 32.9169 29.0585 33.0688C25.2111 34.0061 27.3678 42.0632 27.3678 42.0632",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9002 35.1849C31.3427 35.6298 30.2974 38.6946 30.189 39.8548C30.1065 41.0151 31.6366 44.9683 30.5515 45.3762C29.7506 45.6564 28.9451 41.1647 28.9451 41.1647",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 42.5526C27.4688 42.5526 28.1406 48.1012 30.8991 48.3971",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0171 33.5902C66.0171 33.5902 67.1597 31.8671 69.2475 32.1858C71.7477 32.5838 72.0452 35.2935 72.0652 36.609C72.0846 38.0535 70.9166 39.6991 70.4408 42.2764C69.6215 46.735 69.4008 49.9582 67.3632 49.9491C64.9645 49.9385 64.819 47.8486 64.819 47.8486",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1634 35.3463C66.1672 34.4951 68.2111 33.0856 68.8553 33.2432C72.6942 34.2146 70.4661 42.2522 70.4661 42.2522",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9948 35.3521C66.5484 35.7842 67.5665 38.8581 67.6645 40.0192C67.7368 41.1803 66.1717 45.1197 67.2532 45.5372C68.0515 45.8245 68.8968 41.3402 68.8968 41.3402",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3605 42.7405C70.3605 42.7405 69.6395 48.2829 66.8784 48.5544",
    stroke: "white",
    strokeWidth: 0.471294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgyptsymbol);
export default __webpack_public_path__ + "static/media/Egypt symbol.4140030ccf4b51d5b7cdc4555c3ddc66.svg";
export { ForwardRef as ReactComponent };